module.exports = __webpack_public_path__ + "static/media/SaleandPurchaseofProperty.a81df629.jpg";